import { render } from "./ReAuth.vue?vue&type=template&id=296c7dfe&scoped=true&ts=true"
import script from "./ReAuth.vue?vue&type=script&lang=ts"
export * from "./ReAuth.vue?vue&type=script&lang=ts"

import "./ReAuth.vue?vue&type=style&index=0&id=296c7dfe&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-296c7dfe"]])

export default __exports__